import {useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {useWorkspace} from '../hooks/useWorkspace';
import {FileList, FileUploader, ReverseBotView} from '../components/FileComponents';

const {FiFolder, FiUsers} = FiIcons;

export default function Files() {
  const {files = [], bots = []} = useWorkspace();
  const [activeTab, setActiveTab] = useState('library'); // 'library' | 'reverse'

  return (
    <div className="page">
      <header className="page-header">
        <span className="eyebrow">Files &amp; Context</span>
        <div className="inline spread">
          <div>
            <h1>Shared context, intentionally visible.</h1>
            <p>Tag reference material and control exactly which bots can use it. Feeds the real Knowledge Base pipeline.</p>
          </div>
          <div className="sidebar-tab-header" style={{paddingBottom: 0, borderBottom: 0}}>
            <button
              type="button"
              className={`sidebar-tab-btn ${activeTab === 'library' ? 'active' : ''}`}
              onClick={() => setActiveTab('library')}
            >
              <SafeIcon icon={FiFolder} />
              <span>File Library ({files.length})</span>
            </button>
            <button
              type="button"
              className={`sidebar-tab-btn ${activeTab === 'reverse' ? 'active' : ''}`}
              onClick={() => setActiveTab('reverse')}
            >
              <SafeIcon icon={FiUsers} />
              <span>Access by Bot</span>
            </button>
          </div>
        </div>
      </header>

      {activeTab === 'reverse' ? (
        <ReverseBotView bots={bots} files={files} />
      ) : (
        <div className="files-grid">
          <FileUploader bots={bots} />
          <section className="panel">
            <div className="section-heading">
              <div>
                <span className="eyebrow">Workspace library</span>
                <h2>{files.length} reference documents</h2>
              </div>
            </div>
            <FileList files={files} bots={bots} />
          </section>
        </div>
      )}
    </div>
  );
}
